import type { PlantManagerAsset, PlantManagerComponent } from '@e2grnd/ui-core/dist/types'
import type { ReactNode } from 'react'

import examples from './examples.js'
import params from './params'

export { examples, params }

export const assetParamsMapFn = (pmAsset: PlantManagerAsset, pmComponent: PlantManagerComponent[]) => {
  if(!pmAsset) {
    return { fieldValues: {} }
  }

  console.log('Mapping asset data:\n\tAsset:', pmAsset, '\n\tComponent:', pmComponent)
  const warnings: ReactNode[] = []
  const errors: ReactNode[] = []

  return {
    errors,
    warnings,
    fieldValues: {},
  }
}
